/* src/app/pages/notification-center/notification-center.component.scss */
:host {
}
:host ::ng-deep cds-notification-trigger .notification-trigger {
  overflow: visible;
}
:host ::ng-deep cds-notification-trigger .notification-trigger__icon {
  width: 20px;
  height: 20px;
  background-color: currentColor;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 14.5C8.73333 14.5 9.33333 13.9 9.33333 13.1667H6.66667C6.66667 13.9 7.26667 14.5 8 14.5ZM12 10.5V7.16667C12 5.12 10.9133 3.40667 9 2.95333V2.5C9 1.94667 8.55333 1.5 8 1.5C7.44667 1.5 7 1.94667 7 2.5V2.95333C5.09333 3.40667 4 5.11333 4 7.16667V10.5L2.66667 11.8333V12.5H13.3333V11.8333L12 10.5ZM10.6667 11.1667H5.33333V7.16667C5.33333 5.51333 6.34 4.16667 8 4.16667C9.66 4.16667 10.6667 5.51333 10.6667 7.16667V11.1667Z'/%3E%3C/svg%3E") center/contain no-repeat;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 14.5C8.73333 14.5 9.33333 13.9 9.33333 13.1667H6.66667C6.66667 13.9 7.26667 14.5 8 14.5ZM12 10.5V7.16667C12 5.12 10.9133 3.40667 9 2.95333V2.5C9 1.94667 8.55333 1.5 8 1.5C7.44667 1.5 7 1.94667 7 2.5V2.95333C5.09333 3.40667 4 5.11333 4 7.16667V10.5L2.66667 11.8333V12.5H13.3333V11.8333L12 10.5ZM10.6667 11.1667H5.33333V7.16667C5.33333 5.51333 6.34 4.16667 8 4.16667C9.66 4.16667 10.6667 5.51333 10.6667 7.16667V11.1667Z'/%3E%3C/svg%3E") center/contain no-repeat;
}
:host ::ng-deep cds-notification-trigger .notification-trigger__icon::before {
  content: none;
}
:host ::ng-deep cds-notification-trigger .notification-trigger__badge {
  top: -3px;
  right: -3px;
  left: auto;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  background-color: #d93636;
  transform: none;
}
/*# sourceMappingURL=notification-center.component.css.map */
